import { useTranslation } from "react-i18next";

const navItems = [
  { key: "home", href: "/" },
  { key: "products", href: "/products" },
  { key: "about", href: "/about" },
  { key: "blog", href: "/blog" },
  { key: "contact", href: "/contact" },
];

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-border bg-background">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* ── Top meta row ─────────────────────────────────────── */}
        <div className="flex flex-col gap-3 py-6 ed-eyebrow text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span className="inline-flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand" />
            {t("common.studio")}
          </span>
          <span>{t("common.madeInBrazil")}</span>
        </div>

        {/* ── Main: wordmark + navigation ──────────────────────── */}
        <div className="grid grid-cols-1 gap-12 py-14 border-t border-border lg:grid-cols-[1.2fr_1fr]">
          {/* Wordmark + lede */}
          <div className="flex flex-col justify-between gap-10">
            <div>
              <a href="/" aria-label="Avoria - home" className="inline-flex items-center gap-4">
                <img
                  src="/AvoriaLogo.svg"
                  alt="Avoria"
                  className="w-12 transition-opacity duration-300 dark:invert"
                />
                <span className="ed-display leading-none">
                  Avoria<span className="text-brand">.</span>
                </span>
              </a>
              <p className="ed-serif mt-6 max-w-sm text-2xl text-foreground/80">
                {t("footer.lede")}
              </p>
            </div>

            <a
              href="mailto:contact@avoria.com"
              className="ed-headline w-fit transition-colors duration-200 hover:text-brand"
            >
              contact@avoria.com
            </a>
          </div>

          {/* Numbered navigation */}
          <nav aria-label="Footer">
            <span className="ed-eyebrow text-muted-foreground">{t("footer.index")}</span>
            <ul className="mt-4 border-t border-border">
              {navItems.map((item, i) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="group flex items-baseline gap-4 py-3 border-b border-border"
                  >
                    <span className="ed-eyebrow text-muted-foreground w-7 shrink-0">
                      0{i + 1}
                    </span>
                    <span className="ed-headline text-2xl transition-colors duration-200 group-hover:text-brand">
                      {t(`nav.${item.key}`)}
                    </span>
                    <span className="ed-serif ml-auto text-lg text-muted-foreground transition-colors duration-200 group-hover:text-foreground/70">
                      {t(`nav.${item.key}Sub`)}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* ── Bottom: copyright ────────────────────────────────── */}
        <div className="flex flex-col gap-3 py-8 border-t border-border ed-eyebrow text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>{t("footer.copyright", { year })}</p>
          <div className="flex items-center gap-5">
            <a href="/privacy" className="hover:text-foreground transition-colors duration-200">
              {t("footer.privacy")}
            </a>
            <a href="/faq" className="hover:text-foreground transition-colors duration-200">
              {t("footer.faq")}
            </a>
            <a href="/" className="hover:text-foreground transition-colors duration-200">
              {t("footer.backToTop")} &uarr;
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
